export function toNumberOrNull(value) {
  if (value === null) return null;
  if (value === '') return null;
  return Number(value);
}